<template>
	<main class="mb-6">
		<section v-if="sosCategory.length > 0">
			<swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
				<swiper-slide
					v-for="(item, i) in sosCategory	"
					:key="i"
				>
					<router-link :to="`/layanan/${item.id}?type=${item.name.toLowerCase()}`">
						<img v-lazy="item.icon" alt="" class="responsive" />
					</router-link>
				</swiper-slide>
				<div class="swiper-button-next swiper-button-black" slot="button-next"></div>
	            <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
				<div class="swiper-pagination" slot="pagination"></div>
			</swiper>
			
		</section>
	</main>
</template>
<script>
	import 'swiper/dist/css/swiper.min.css'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'
	export default {
		components: {
			swiperSlide,
			swiper
		},
		data: () => ({
			sosCategory: [],
			swiperOption: {
		        slidesPerView: 4,
		    	spaceBetween: 30,
		    	breakpoints: {
					1440: {
						slidesPerView: 4,
						spaceBetween: 40
					},
		        	1024: {
		          		slidesPerView: 3,
		          		spaceBetween: 40
		        	},
		        	768: {
		          		slidesPerView: 2,
		          		spaceBetween: 30
		        	},
		        	640: {
		          		slidesPerView: 1,
		          		spaceBetween: 20
		        	}
		      },
		    	navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}
			}
		}),
		methods: {
			getSosCategory() {
				this.$store.dispatch('sos/getCategory')
				.then(category => {
					if(category.length > 0) {
						const datas = JSON.parse(JSON.stringify(category.slice()));
						datas.map(item => {
							item.icon = `/assets/images/sos/${item.name.toLowerCase()}.png`
						});
						this.sosCategory = datas;
					}
				});
			}
		},
		created() {
			this.getSosCategory()
		}
	}
</script>
<style>
	.service-card {
		background: rgb(4,85,50);
background: linear-gradient(135deg, rgba(4,85,50,1) 0%, rgba(29,102,14,1) 35%, rgba(39,152,16,1) 100%);

	}
	.service-card:hover {
		background: #FFCB05;
	}
</style>